// extracted by mini-css-extract-plugin
export default {"cell-state":"cell-state--GSvtB","cellState":"cell-state--GSvtB","cell-state__spinner":"cell-state__spinner--mF8dd","cellStateSpinner":"cell-state__spinner--mF8dd"};